var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 49,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#linkedin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M48.25 24.705c0 12.979-10.521 23.5-23.5 23.5s-23.5-10.521-23.5-23.5 10.521-23.5 23.5-23.5 23.5 10.521 23.5 23.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M34.108 24.874v6.418h-3.721v-5.988c0-1.504-.538-2.53-1.885-2.53-1.028 0-1.639.69-1.909 1.36-.098.24-.123.572-.123.907v6.25H22.75s.05-10.141 0-11.191h3.721v1.586c-.007.012-.018.025-.024.037h.024v-.037c.495-.761 1.377-1.849 3.354-1.849 2.448 0 4.284 1.6 4.284 5.037M18.856 14.705c-1.273 0-2.106.836-2.106 1.934 0 1.074.809 1.934 2.057 1.934h.024c1.298 0 2.105-.86 2.105-1.934-.025-1.098-.807-1.934-2.08-1.934M16.97 31.292h3.72V20.1h-3.72z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkedin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.75.629h48v48h-48z"
})))));
export default SvgLinkedin;